import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Box, CircularProgress } from "@mui/material";
import { useRef, useState } from "react";
import { menuBtnStyles, menuStyles } from "./styles";

const CustomMenu = (props) => {
  const { menuBtnText, menuBtnIconPath, menuItems } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);
  const buttonRef = useRef(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (buttonRef.current) {
      setMenuWidth(buttonRef.current.offsetWidth);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        ref={buttonRef}
        onClick={handleClick}
        sx={{
          ...menuBtnStyles,
          backgroundColor: open ? "#0000000D" : "transparent",
        }}
      >
        {menuBtnIconPath && <img src={menuBtnIconPath} alt="menu_icon" />}
        {menuBtnText}
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{
          ...menuStyles,
          ".MuiPaper-root": {
            minWidth: menuWidth,
          },
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={async () => {
              if (item.loading && item.keepOpenOnLoading) {
                return;
              }

              const result = item.onClick?.();

              if (item.keepOpenOnLoading && result instanceof Promise) {
                await result;
              }

              handleClose(); 
            }}

            disabled={item.disabled || item.loading}
          >
            {item.iconPath && <img src={item.iconPath} alt="item_icon" />}
            {item.text}
            {item.loading && <CircularProgress sx={{
              color: "#248B70",
            }} size={20} />}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default CustomMenu;
